



import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import Parse from '../parseConfig';


/**
 * A wrapper component that ensures only authenticated users
 * can access certain routes. If the user is not logged in,
 * it redirects them to the login page and preserves the
 * original URL via a 'redirectTo' query param.
 */

const RequireAuthRoute = ({ component: Component, ...rest }) => {

  const currentUser = Parse.User.current();       // Get the currently logged-in user
  const location = useLocation();                 // Access the current route path and query params

  if (!currentUser) {
    // Capture the full URL path and query string the user originally tried to visit
    const redirectTo = `${location.pathname}${location.search}`;

    // Save it to sessionStorage so we can redirect back to it after login or guest login
    sessionStorage.setItem('redirectTo', redirectTo);

    // Redirect to the welcome screen (not directly to login)
    return <Navigate to="/" replace />;
  }

  // If user is authenticated, render the intended component with all props
  return <Component {...rest} />;
};

export default RequireAuthRoute;


